import Swiper from "swiper";
import { Navigation, Pagination, A11y } from "swiper/modules";

const initTestimonialsSlider = () => {
  document.querySelectorAll(".testimonials-slider").forEach((el) => {
    new Swiper(el, {
      modules: [Navigation, Pagination, A11y],
      speed: 500,
      watchOverflow: true,
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
      a11y: {
        prevSlideMessage: "Previous testimonial",
        nextSlideMessage: "Next testimonial",
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });

  document.querySelectorAll(".testimonials-full-slider").forEach((el) => {
    new Swiper(el, {
      modules: [Navigation, Pagination, A11y],
      speed: 500,
      watchOverflow: true,
      slidesPerView: 1,
      a11y: {
        prevSlideMessage: "Previous testimonial",
        nextSlideMessage: "Next testimonial",
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });
};

const initTeamCarousel = () => {
  document.querySelectorAll(".team-carousel").forEach((el) => {
    new Swiper(el, {
      modules: [Navigation, Pagination, A11y],
      speed: 500,
      watchOverflow: true,
      slidesPerView: 1,
      a11y: {
        prevSlideMessage: "Previous photo",
        nextSlideMessage: "Next photo",
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });
};

const init = () => {
  initTestimonialsSlider();
  initTeamCarousel();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
